import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { EventTimePickerComponent } from '../event-time-picker/event-time-picker.component'
import { DayWeekShort } from '../../../../types/event.type'
import { NgClass } from '@angular/common'

@Component({
  selector: 'app-weekly-hours-editor',
  standalone: true,
  templateUrl: './weekly-hours-editor.component.html',
  styleUrl: './weekly-hours-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EventTimePickerComponent, NgClass]
})
export class WeeklyHoursEditorComponent {
  public readonly weekDayOptions = input.required<readonly DayWeekShort[]>()
  public readonly selectedWeekDays = input.required<readonly DayWeekShort[]>()
  public readonly dayWeekFullName = input.required<Record<DayWeekShort, string>>()

  public readonly openingHoursMode = input.required<'same' | 'different'>()
  public readonly isDisabled = input.required<boolean>()

  public readonly sameHoursStartHour = input.required<string>()
  public readonly sameHoursStartMinute = input.required<string>()
  public readonly sameHoursEndHour = input.required<string>()
  public readonly sameHoursEndMinute = input.required<string>()
  public readonly sameHoursError = input.required<string | null>()

  public readonly perDayHours = input.required<Record<DayWeekShort, { startHour: string; startMinute: string; endHour: string; endMinute: string }>>()
  public readonly perDayErrorByDay = input.required<Record<DayWeekShort, string | null>>()

  public readonly toggleWeekDay = output<DayWeekShort>()
  public readonly openingHoursModeChange = output<'same' | 'different'>()
  public readonly sameHoursChange = output<Partial<{ startHour: string; startMinute: string; endHour: string; endMinute: string }>>()
  public readonly perDayHoursChange = output<{ day: DayWeekShort; patch: Partial<{ startHour: string; startMinute: string; endHour: string; endMinute: string }> }>()

  /** Emit weekday toggle. */
  public onToggleWeekDay(day: DayWeekShort): void {
    this.toggleWeekDay.emit(day)
  }

  /** Emit opening-hours mode change. */
  public onOpeningHoursModeChange(mode: 'same' | 'different'): void {
    this.openingHoursModeChange.emit(mode)
  }

  /** Emit same-hours patch. */
  public onSameHoursPatch(patch: Partial<{ startHour: string; startMinute: string; endHour: string; endMinute: string }>): void {
    this.sameHoursChange.emit(patch)
  }

  /** Emit per-day hours patch. */
  public onPerDayPatch(day: DayWeekShort, patch: Partial<{ startHour: string; startMinute: string; endHour: string; endMinute: string }>): void {
    this.perDayHoursChange.emit({ day, patch })
  }
}
